/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class PaymentConfigurationModel {

        public selectedPaymentConfiguration: Wars.Domain.Model.Payment.PaymentConfiguration;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public isReadonly: boolean;
        public calculations: Wars.Domain.Model.Calculations.Calculation[];
        public customActionContract: Wars.Domain.Model.ExtensibleContract;
        public processActions: Wars.Domain.Model.ProcessAction[];

        private systemLevel: Wars.Domain.Model.SystemLevel;

        constructor(
            private processConfigurationId: string,
            private processConfigService: services.ProcessConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private paymentConfigurationService: services.PaymentConfigurationService,
            private calculationService: services.CalculationService,
            private extensibilityService: services.ExtensibilityService,
            private processActionService: services.ProcessActionService,
            private deleteService: services.DeleteService,
            private treeService: services.TreeService,
            private growlService: angular.growl.IGrowlService) {

            if (this.processConfigurationId) {
                this.processConfigService.getProcessConfigurationEagerLoadPaymentInfo(this.processConfigurationId).then(
                (processConfiguration) => {
                    if (processConfiguration == null) {
                        this.isReadonly = true;
                        this.growlService.error("Could not find process configuration: " + this.processConfigurationId);
                    } else {
                        this.processConfiguration = processConfiguration;
                        if (this.processConfiguration.minorVersion != null) this.isReadonly = true;
                    }
                });
            } else {
                this.systemLevelService.getSystemLevelPaymentInfo().then(
                (systemLevel) => {
                    this.systemLevel = systemLevel;
                });
            }

            this.calculationService.getAllSequenceCalculations(this.processConfigurationId).then(
                (calculations) => {
                    this.calculations = calculations;
                });

            this.extensibilityService.getCustomActionContract().then(
            (customActionContract) => {
                this.customActionContract = customActionContract;
            });

            if (this.processConfigurationId) {
                this.processActionService.getAllProcessActions(this.processConfigurationId).then(
                (processActions) => {
                    this.processActions = processActions;
                });
            }
        }

        public getPaymentConfigurations(): Array<Wars.Domain.Model.Payment.PaymentConfiguration> {
            if (this.systemLevel) return this.systemLevel.myPaymentConfigurations;
            if (this.processConfiguration) return this.processConfiguration.myPaymentConfigurations;
            return [];
        }

        public editPaymentConfiguration(index: number): void {
            this.selectedPaymentConfiguration = this.getPaymentConfigurations()[index];
        }

        public deletePaymentConfiguration(index: number): void {
            var paymentConfig = this.getPaymentConfigurations()[index];
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "PaymentConfiguration",
                paymentConfig.id,
                "Payment Configuration",
                () => {
                    this.getPaymentConfigurations().splice(index, 1);
                    this.selectedPaymentConfiguration = undefined;
                });
        }

        public addNewPaymentConfiguration(): void {
            this.selectedPaymentConfiguration = this.paymentConfigurationService.createNewPaymentConfig();
            this.getPaymentConfigurations().push(this.selectedPaymentConfiguration);
        }

        public saveChanges(): void {
            this.processConfigService.saveAllChanges();
        }

        public onDragOver($event: any, $index: number): void {
            //var treeConfig = this.treeService.getTreeConfigurationItem();
        }

        public onDrop($event: any, $index: number): void {
            var treeItem = this.treeService.createTreeItemFromItemDropped();
            this.selectedPaymentConfiguration.amountTreeItem = treeItem;
            this.selectedPaymentConfiguration.amountTreeItem_id = treeItem.id;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
            this.saveChanges();
        }

        public onCalculateDragOver($event: any, $index: number): void {
            
        }

        public onCalculateDrop($event: any, $index: number): void {
            var treeConfig = this.treeService.getTreeConfigurationItem();
            this.selectedPaymentConfiguration.myPaymentCustomInformation[$index].valueCalculation_id = treeConfig.calculationId;

            this.calculationService.getCalculation(treeConfig.calculationId).then(
                (calculation) => {
                    this.selectedPaymentConfiguration.myPaymentCustomInformation[$index].valueCalculation = calculation;
                });

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
            this.saveChanges();
        }

        public onFieldDragOver($event: any, $index: number): void {
        }

        public onFieldDrop($event: any, $index: number): void {
            var treeItem = this.treeService.createTreeItemFromItemDropped();

            this.selectedPaymentConfiguration.myMappings[$index].treeItem = treeItem;
            this.selectedPaymentConfiguration.myMappings[$index].treeItem_id = treeItem.id;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
            this.saveChanges();
        }

        public clearMapping($index: number): void {
            this.selectedPaymentConfiguration.myMappings[$index].treeItem.entityAspect.setDeleted();
            this.selectedPaymentConfiguration.myMappings[$index].treeItem = undefined;
            this.selectedPaymentConfiguration.myMappings[$index].treeItem_id = undefined;
            this.saveChanges();
        }

        public getDisplayName(treeItem: Wars.Domain.Model.TreeItem): string {
            return this.treeService.getDisplayName(treeItem);
        }

        public addNewCustomInfo(): void {
            this.selectedPaymentConfiguration.myPaymentCustomInformation.push(this.paymentConfigurationService.createNewCustomInfo(this.selectedPaymentConfiguration.id));
            this.saveChanges();
        }

        public deleteCustomInfo(index: number): void {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "PaymentCustomInformation",
                this.selectedPaymentConfiguration.myPaymentCustomInformation[index].id,
                "Payment Custom Information",
                () => {
                    this.selectedPaymentConfiguration.myPaymentCustomInformation.splice(index, 1);
                });
        }
    }
}